import React from 'react';
// import { GatsbyImage } from 'gatsby-plugin-image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Autoplay, Navigation } from 'swiper';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import { shuffle } from 'lodash';

const testimonials = [
  {
    name: 'Kajal Kundanani',
    title: 'Assistant HR Manager',
    company: 'CommVersion',
    companyLogo: '/images/Testimonial/CImage1.png',
    image: '/images/Testimonial/RImage1.png',
    quote:
      'Crio presented us with a diverse pool of candidates who not only met our job specifications but also aligned well with our company values',
  },
  {
    name: 'Yash Singhal',
    title: 'Founder',
    company: 'Revly',
    companyLogo: '/images/Testimonial/CImage2.png',
    image: '/images/Testimonial/RImage2.png',
    quote:
      "The candidates they presented were all highly qualified and a great fit for our team. We'll definitely be using Crio.Do again for future hiring needs!",
  },
  {
    name: 'Neha Daniel',
    title: 'Human Resources Recruiter',
    company: 'vizmo',
    companyLogo: '/images/Testimonial/CImage5.png',
    image: '/images/Testimonial/RImage5.png',
    quote:
      'The team truly excelled in bringing quality candidates that aligned with our job specifications.',
  },
  {
    name: 'Shubham Jain',
    title: 'Founder',
    company: 'TradeTroop',
    companyLogo: '/images/Testimonial/CImage3.png',
    image: '/images/Testimonial/RImage3.png',
    quote:
      "Crio's platform made hiring full-stack developers a breeze. The process was smooth, flexible, and they delivered a pool of qualified candidates. Highly recommend!",
  },
  {
    name: 'Nandakumar R',
    title: 'Associate - Sales And Client Relations',
    company: 'Kristalball',
    companyLogo: '/images/Testimonial/CImage4.png',
    image: '/images/Testimonial/RImage4.png',
    quote:
      'Crio Do has been instrumental in helping us build a stronger team, and I highly recommend it to other hiring professionals.',
  },
  {
    name: 'Sheetal',
    title: 'Human Resources Executive',
    company: 'UnknownCompany', // Company logo shows a green 'A', but name isn't clear. Adjust accordingly.
    companyLogo: '/images/Testimonial/CImage6.png',
    image: '/images/Testimonial/RImage6.png',
    quote:
      'Crio created a proper streamline of candidates that aligned with our job roles. We are very pleased with the candidates you sourced for us.',
  },
];

const RecruiterCarousel = React.memo(function RecruiterCarousel(props) {
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const swiperRef = React.useRef(null);

  // Swiper settings
  const settings = {
    slidesPerView: 1,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 3,
      },
    },
    loop: true,
    spaceBetween: 20,
    speed: 300,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current,
    },
    modules: [Navigation, Autoplay],
  };

  return (
    <div className="relative w-full max-w-[1166px]">
      <Swiper ref={swiperRef} {...settings}>
        {shuffle(testimonials).map((testimonial, idx) => {
          return (
            <SwiperSlide
              key={testimonial.name?.trim() || idx}
              className="px-6 sm:px-0"
            >
              <SimpleTestimonialCard
                name={testimonial.name}
                title={testimonial.title}
                companyLogo={testimonial.companyLogo}
                image={testimonial.image}
                quote={testimonial.quote}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>

      {/* Navigation Arrows */}
      <div
        onClick={() => swiperRef.current.swiper.slidePrev()}
        ref={navigationPrevRef}
        className="absolute top-1/2 -left-20 z-10 -translate-y-1/2 transform cursor-pointer hover:opacity-75"
      >
        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-gray-300 bg-[#f3faf7]">
          <FontAwesomeIcon
            icon={['fas', 'chevron-left']}
            className="text-gray-500"
          />
        </div>
      </div>

      <div
        onClick={() => swiperRef.current.swiper.slideNext()}
        ref={navigationNextRef}
        className="absolute top-1/2 -right-20 z-10 -translate-y-1/2 transform cursor-pointer hover:opacity-75"
      >
        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-gray-300 bg-[#f3faf7]">
          <FontAwesomeIcon
            icon={['fas', 'chevron-right']}
            className="text-gray-500"
          />
        </div>
      </div>
    </div>
  );
});

export default RecruiterCarousel;

// SimpleTestimonialCard component
const SimpleTestimonialCard = ({ name, title, companyLogo, image, quote }) => {
  return (
    <div className="flex flex-col items-center px-4 py-8 text-center">
      {/* Quote box */}
      <div className="relative mb-10 flex items-center justify-center bg-[#f3faf7] p-6 md:h-[300px] md:rounded-[40px]">
        <p className="font-rubik text-base font-normal text-[#02382C] md:text-[20px] md:leading-[33px]">
          “{quote}”
        </p>
        {/* Arrow below quote box */}
        <div className="absolute left-1/2 bottom-[-10px] h-5 w-5 -translate-x-1/2 rotate-45 transform bg-[#f3faf7]"></div>
      </div>

      {/* Diamond shaped profile image */}
      <div className="relative mb-4">
        <div className="flex h-20 w-20 rotate-45 items-center justify-center overflow-hidden rounded-lg">
          {typeof image === 'string' ? (
            <img
              src={image}
              alt={name}
              style={{
                transform: 'rotate(-45deg)',
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          ) : (
            <></>
          )}
        </div>
      </div>

      {/* Name */}
      <h4 className="font-manrope text-lg font-semibold text-black md:text-[24px]">
        {name}
      </h4>

      {/* Title */}
      <p className="mb-4 font-manrope text-sm font-medium text-[#7A8B87] md:text-[18px]">
        {title}
      </p>

      {/* Company Logo */}
      <div className="h-[32px]">
        {typeof companyLogo === 'string' ? (
          <img
            src={companyLogo}
            alt="Company Logo"
            style={{ objectFit: 'contain', width: 'auto', height: '100%' }}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
